import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LogoContext = createContext({ logoUrl: '/logo.jpg', refreshLogo: () => {} });

export function LogoProvider({ children }) {
  const [logoUrl, setLogoUrl] = useState('/logo.jpg');

  const refreshLogo = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/settings/logo`);
      if (res.data.logo_url) {
        setLogoUrl(`${API_URL}${res.data.logo_url}`);
      } else {
        setLogoUrl('/logo.jpg');
      }
    } catch {
      setLogoUrl('/logo.jpg');
    }
  }, []);

  useEffect(() => {
    refreshLogo();
  }, [refreshLogo]);

  useEffect(() => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) favicon.href = logoUrl;
    const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (appleTouchIcon) appleTouchIcon.href = logoUrl;
  }, [logoUrl]);

  return (
    <LogoContext.Provider value={{ logoUrl, refreshLogo }}>
      {children}
    </LogoContext.Provider>
  );
}

export const useLogo = () => useContext(LogoContext);
